import { router } from '@inertiajs/react'

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void
  }
}

// Inertia の画面遷移（フルリロードしない）でも Google Analytics に page_view を送る。
// 初回の表示は layout の gtag('config') が送るので、2 回目以降の遷移だけを送る。
export function trackPageViews(): void {
  let initial = true
  router.on('navigate', () => {
    if (initial) {
      initial = false
      return
    }
    window.gtag?.('event', 'page_view', { page_location: window.location.href, page_title: document.title })
  })
}
